export default "__VITE_ASSET__XjfL2n_n__"